import { defineStore } from 'pinia';
import splitBillingService from '@/services/splitBillingService';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
const useSplitBillingStore = defineStore('splitBillingStore', {
  state: () => {
    const {
      handleError
    } = useSnackbarHandler();
    return {
      allocations: [],
      loading: false,
      handleError
    };
  },
  getters: {
    totalPercentage: state => state.allocations.reduce((total, allocation) => total + allocation.percentage, 0),
    isValidAllocation: state => state.allocations.length > 0 && state.totalPercentage === 100
  },
  actions: {
    async loadAllocations(matterId) {
      if (!matterId) {
        throw new Error('Matter ID is required');
      }
      this.loading = true;
      try {
        const data = await splitBillingService.loadAllocations(matterId);
        this.allocations = data;
        return data;
      } catch (error) {
        this.handleError(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async createAllocation(matterId, allocation) {
      if (!matterId) {
        throw new Error('Matter ID is required');
      }
      this.loading = true;
      try {
        const data = await splitBillingService.createAllocation(matterId, allocation);
        this.allocations.push(data);
        return data;
      } catch (error) {
        this.handleError(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async updateAllocation(allocationId, updates) {
      if (!allocationId) {
        throw new Error('Matter ID and Allocation ID are required');
      }
      this.loading = true;
      try {
        const data = await splitBillingService.updateAllocation(allocationId, updates);
        const index = this.allocations.findIndex(a => a.id === allocationId);
        if (index !== -1) {
          this.allocations[index] = data;
        }
        return data;
      } catch (error) {
        this.handleError(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async deleteAllocation(allocationId) {
      if (!allocationId) {
        throw new Error('Allocation ID is required');
      }
      this.loading = true;
      try {
        await splitBillingService.deleteAllocation(allocationId);
        this.allocations = this.allocations.filter(a => a.id !== allocationId);
      } catch (error) {
        this.handleError(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
    clearAllocations() {
      this.allocations = [];
    },
    setAllocations(allocations) {
      this.allocations = allocations || [];
    }
  }
});
export default useSplitBillingStore;